<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Eigene Rechnungen</v-card-title>
    <v-simple-table dense fixed-header>
      <thead>
        <tr>
          <th>Rechnungsnummer</th>
          <th class="text-right">Summe</th>
          <th class="text-right">Zahlbar bis</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in rechnungen" :key="item.name" v-on:dblclick="goToId(item.id)">
          <td>{{ item.rechnungsnummer }}</td>
          <td class="text-right">{{ item.summe | money }}</td>
          <td class="text-right">{{ $filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY") }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
  export default {
    props: ["bbr"],
    computed: {
      rechnungen() {
        if (this.$store.state.rechnungen.loadedEigene === false) {
          if (this.bbr != null) {
            this.$store.dispatch("rechnungen/loadEigeneRechnungen", { user: this.bbr });
          }
        }
        return this.$store.getters["rechnungen/nutzerRechnungenOffen"](this.bbr);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// rechnungenEigene.vue?7bdd5aa2